import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { ExtendedBaseProfileField } from '../../../../../core/profiles/entities/extended-profile-field.entity';
import { PartialRecord } from '../../../../../core/records/entities/partial-record.class';
import { ShFormDateComponent } from '../../../../../form-controls/components/form-date/main/form-date.component';
import { FormValue, FormValueState } from '../../../../../form-controls/entities/form-value.entity';
import { BatchFieldReadHelper } from '../../../../helpers/fields/batch-field-read.helper';
import { FieldReadHelper } from '../../../../helpers/fields/field-read.helper';
import { ShSimpleInputFieldComponent } from '../simple-input-field/simple-input-field.component';

@Component({
    standalone: true,
    selector: 'sh-date-field',
    templateUrl: './date-input-field.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ShFormDateComponent, CommonModule, TranslateModule]
})
export class ShDateInputFieldComponent extends ShSimpleInputFieldComponent {
    constructor(
        protected fieldHelper: FieldReadHelper,
        private readonly datePipe: DatePipe
    ) {
        super(fieldHelper);
    }

    init(profileField: ExtendedBaseProfileField, records: PartialRecord[], control: UntypedFormControl): void {
        const mergedDateField: FormValue<string | null> = this.isBatchEdit
            ? (BatchFieldReadHelper.getBatchFieldValue(profileField.FieldDefinition) as FormValue<string | null>)
            : this.fieldHelper.getMergedDateFieldValue(profileField.FieldDefinition, records);

        const isIndeterminate: boolean = mergedDateField.state === FormValueState.INDETERMINATE;

        // MED-5979: Batch-edit fixes and improvements
        // Do not set value in case of Indeterminate value and Readonly field
        // Setting the indeterminate value, sets the placeholder, which in turn enables the control itself
        // This is an HTML issue
        if (isIndeterminate && (profileField.FieldDefinition.ReadOnly || profileField.ReadOnly)) {
            return;
        }
        control.setValue(mergedDateField);
    }

    get dateExample(): string {
        // TODO: Localized Date format
        return this.datePipe.transform(new Date(), 'dd-MM-yyyy') || '28-02-2020';
    }
}
